<template>
    <div class="header-challenge">
        <h1>{{ textH1 }}</h1>
        <h2>{{ textH2 }}</h2>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            textH1: { type: String, default: 'Lorem Ipsum' },
            textH2: { type: String, default: 'Lorem ipsum dolor sit amet.'},
        }
    };
</script>

<style scoped src="@/css/components/header-challenge.css"></style>